<app-modal
  #modal
  [modalConfig]="{
    titleText: 'Filter Results',
    headerClass: ['modal-header', 'bg-primary', 'text-white'],
    customFooter: true
  }">
  <button
    class="bg-transparent border-0"
    title="Close"
    aria-label="close"
    headerContent
    (click)="closeModal()">
    <i class="bi bi-x-lg text-white"></i>
  </button>

  <div class="row gy-3">
    <div class="col-md-12 gx-5">
      <label class="form-label">District:</label>
      <app-district-select
        #districtSelect
        [clearAfterSelection]="false"
        [simpleSelect]="true"
        [clearable]="true"
        [defaultDistricts]="
          this.currentFilters.district ? [this.currentFilters.district] : []
        "
        (selectedDistrict)="clearFilters($event)" />
    </div>
  </div>
  <div class="row gy-3">
    <div class="col-md-12 gx-5">
      <label class="form-label">Schools:</label>
      <app-school-select
        #schoolSelect
        [clearAfterSelection]="false"
        [isMulti]="true"
        [districtId]="
          this.currentFilters.district
            ? [this.currentFilters.district.id]
            : undefined
        "
        [assignedCoacheesSchoolsOnly]="!canSeeAllSchools"
        [defaultSchools]="this.currentFilters.schoolList"
        (selectedSchoolList)="updateSchools($event)" />
    </div>
  </div>
  <div class="row gy-3">
    <div class="col-md-12 gx-5">
      <label class="form-label">Users:</label>
      <app-user-select
        #userSelect
        [clearAfterSelection]="false"
        [isMulti]="true"
        [districtId]="
          this.currentFilters.district ? this.currentFilters.district.id : null
        "
        [defaultUsers]="this.currentFilters.userList"
        (selectedUserList)="this.currentFilters.userList = $event" />
    </div>
  </div>
  <div class="row datePickerRow noTop gy-3">
    <label class="form-label">Date Range:</label>
    <app-daterange-picker
      #dateSelect
      [fromDate]="this.currentFilters.fromDate"
      [toDate]="this.currentFilters.toDate"
      (selectedFromDate)="$event && (this.currentFilters.fromDate = $event)"
      (selectedToDate)="
        $event && (this.currentFilters.toDate = $event)
      "></app-daterange-picker>
  </div>
  <div footerContent>
    <div class="d-flex justify-content-between">
      <button type="button" class="btn" (click)="clearFilters()">
        Clear All
      </button>
      <button
        type="button"
        class="btn btn-md btn-primary"
        (click)="closeModal()">
        Apply
      </button>
    </div>
  </div>
</app-modal>
